import { useContext, useState } from "react";
import {
  AuthContext,
  ViewContext,
  useNavigate,
  Loader,
  Card,
} from "@/components/lib";
import ghsLogo from "@/images/grapevine_football_transparent.png";
import axios from "axios";
import { useForm } from "react-hook-form";
import Styles from "@/css/mainStyles";

export function Signin() {
  // context
  const authContext = useContext<any>(AuthContext);
  const viewContext = useContext<any>(ViewContext);
  // --------------------
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const res = await axios({
        method: "post",
        url: `${authContext.remote_server}/api/auth`,
        data
      });

      res.data["2fa_required"]
        ? navigate(`/signin/otp?token=${res.data.token}`)
        : navigate(authContext.signin(res));
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.response.data?.message || error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-screen p-8 md:px-32 text-left lg:w-1/2">
      <Card className="w-full lg:w-4/5 m-auto">
        <div className="bg-black">
          <img src={ghsLogo} alt="Logo" className="w-80 lg:w-96 mx-auto " />
        </div>
        <h1 className="font-bold text-2xl lg:text-4xl text-center my-7">Login</h1>
        <form
          className="flex flex-col items-center gap-6"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="flex flex-col flex-1 w-full">
            <label className={Styles.label}>Email</label>
            <input
              placeholder="Enter Email"
              type="email"
              className={Styles.input}
              {...register("email", { required: true })}
              style={errors.email && { border: "1px solid red" }}
            />
          </div>
          <div className="flex flex-col flex-1 w-full">
            <label className={Styles.label}>Password</label>
            <input
              placeholder="Enter Password"
              type="password"
              className={Styles.input}
              {...register("password", { required: true })}
              style={errors.password && { border: "1px solid red" }}
            />
          </div>
          {/* <Link className="lg:text-lg mr-auto">Forgot your password?</Link> */}
          <button type="submit" className={Styles.submitButton}>
            Continue
            {loading && <Loader />}
          </button>
        </form>
      </Card>
    </div>
  );
}
